import { schema } from 'normalizr';

export const ENTITY_CUSTOMERS = 'customers'
export const ENTITY_CUSTOMERS_LIST = 'customersList'
export const ENTITY_CUSTOMER_TAGS = 'customerTags'
export const ENTITY_ADDRESSES = 'addresses'
export const ENTITY_ADDRESSES_LIST = 'addressesList'

export const addressSchema = new schema.Entity(ENTITY_ADDRESSES)

const addressesSchema = new schema.Entity(ENTITY_ADDRESSES_LIST, {
  data: [addressSchema]
}, {idAttribute: (value, parent) => parent.id});

export const customerTagsSchema = new schema.Entity(ENTITY_CUSTOMER_TAGS, {
}, {idAttribute: (value, parent) => parent.id});

export const customersSchema = new schema.Entity(ENTITY_CUSTOMERS, {
  addresses: addressesSchema,
  tags: customerTagsSchema
});

export const customersListSchema = new schema.Entity(
  ENTITY_CUSTOMERS_LIST,
  { data: [customersSchema] }
)
